import { IBase, IReportTemplate, IResponsible } from '@shared/interfaces';
import { ReportStatus } from '@shared/enums/ReportStatus';
import { ISignature } from '@shared/interfaces/reports/ISignature';
import { IReportLight } from '@shared/interfaces/reports/IReportLight';

export interface IReport extends IReportLight, IBase {
    selectedLanguage?: string;
    guidanceValues?: { [key: string]: boolean };
    reportValues?: { [key: string]: IReportValue };
    template?: IReportTemplate;
    responsibleSignature?: ISignature;
    specialistSignature?: ISignature | ISignature[];
    reportDocuments?: Array<IReportDocument | File>;
    documents?: Array<IReportDocument | File>;
    exportStatus?: ReportStatus;
    responsible?: IResponsible;

    signDocuments?: Array<IReportDocument | File>;
    deleteDocuments?: string[];

    notifyResponsible?: boolean;

    children?: IReport[];
    title?: string;
    totalItems?: number;
    releasedItems?: number;
    draftItems?: number;
    inProgressItems?: number;
    endNode?: boolean;

    isUploadedManually?: boolean;
}

export interface IReportDocument {
    lastModified?: string;
    size?: number;
    name?: string;
    keyId?: string;
    body?: { type: string; data: Array<number> };
    id?: string;
    link?: string;
}

export class IReportValue {
    value: string;
    approved: boolean;
}
